import script from "./ButtonElement.vue?vue&type=script&lang=js"
export * from "./ButtonElement.vue?vue&type=script&lang=js"

import "./ButtonElement.vue?vue&type=style&index=0&id=501d6c91&lang=scss"

const __exports__ = script;

export default __exports__